export const platforms = [
  {
    name: '探探',
    icon: 'ri-heart-line',
    rating: 4.5,
    users: '1亿+',
    description: '国内最热门的社交匹配软件，以颜值匹配为核心，用户基数庞大，匹配效率高，适合追求高效约会的用户。',
    pros: ['用户基数大，匹配机会多', '操作简单直观', '颜值匹配效率高', 'VIP会员功能丰富'],
    cons: ['颜值导向明显', '存在少量假账号', '免费版功能有限'],
    color: 'primary' as const,
  },
  {
    name: '陌陌',
    icon: 'ri-map-pin-line',
    rating: 4.3,
    users: '8000万+',
    description: '老牌社交平台，功能丰富多元，群组社交和附近的人功能是核心特色，适合喜欢多元化社交方式的用户。',
    pros: ['功能丰富多样', '群组社交有深度', '附近的人功能实用', '用户群体广泛'],
    cons: ['界面略显复杂', '部分功能收费', '信息筛选需要时间'],
    color: 'accent' as const,
  },
  {
    name: 'Soul',
    icon: 'ri-voiceprint-line',
    rating: 4.4,
    users: '5000万+',
    description: '主打灵魂社交概念，通过匿名语音和文字建立连接，降低了外貌焦虑，适合声音和内在魅力突出的用户。',
    pros: ['匿名社交降低压力', '语音匹配有特色', '用户质量相对较高', '社区氛围较好'],
    cons: ['无法提前看照片', '见面可能有反差', '部分功能需要付费'],
    color: 'secondary' as const,
  },
  {
    name: '积目',
    icon: 'ri-focus-3-line',
    rating: 4.2,
    users: '3000万+',
    description: '面向年轻用户的社交平台，以兴趣标签和视觉展示为特色，玩法新潮多元，适合追求个性化社交的年轻群体。',
    pros: ['兴趣标签精准匹配', '年轻用户为主', '视觉展示效果好', '社交玩法新颖'],
    cons: ['用户年龄偏小', '部分地区用户少', '部分高级功能需付费'],
    color: 'primary' as const,
  },
];